import React from 'react';
import ResourceHelper from '../../helpers/ResourceHelper';
import { IconVariation, T } from '@testout/labsim-ui-atomics';
import { decodeUnicodeEscapes } from '../../helpers/TextHelper';
export default class ResourceSelectionControl extends React.Component {
    constructor(props) {
        super(props);
        this.handleCheckbox = (checked) => {
            this.props.onSelect([this.props.resource], checked);
        };
    }
    render() {
        const icon = ResourceHelper.getResourceIcon(this.props.resource.type, IconVariation.Exam);
        let sectionNumber = this.props.resource.sectionNumber;
        const sectionTitle = decodeUnicodeEscapes(this.props.resource.sectionTitle);
        if (sectionTitle.includes(sectionNumber)) {
            sectionNumber = '';
        }
        return (React.createElement(T.Input.Checkbox, { checked: this.props.checked, onChange: this.handleCheckbox, disabled: this.props.disabled, name: 'resourceCheckbox', automationId: this.props.resource.sectionNumber },
            React.createElement("div", { className: 'resource-label' },
                React.createElement(T.Icon, { automationId: `${this.props.resource.sectionNumber} icon`, className: 'resource-icon', variation: icon }),
                React.createElement(T.Text.Span, { automationId: 'label' }, `${sectionNumber} ${this.props.titleOverride || sectionTitle}`))));
    }
}
//# sourceMappingURL=ResourceSelectionControl.js.map